
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.054.897a.75.75 0 01.976 1.133L8.061 7l4.97 4.97a.75.75 0 01-.977 1.133l-.084-.073L7 8.061l-4.97 4.97-.084.072A.75.75 0 01.97 11.97L5.939 7 .969 2.03A.75.75 0 011.947.897L2.03.97 7 5.939l4.97-4.97z","fill":"#363636","fill-rule":"nonzero"}})])
          )
        }
      }
    